import configData from '../../utils/config'

const initialValues = { username: '', password: '' }

const formData = t => ({
  username: {
    label: t('auth_UserName'),
    validateTrigger: 'onChange',
    rules: [
      { required: true },
      { pattern: /^\S*$/, message: t('spaceNotAllowInUser') },
    ],
    inputType: 'input',
    md: 24,
  },
  password: {
    label: t('auth_Password'),
    validateTrigger: 'onChange',
    rules: [{ required: true }],
    inputType: 'password',
  },
})

const infoBean = {
  androidId: 'string',
  androidVersion: 'string',
  appName: configData?.APP_NAME,
  appSignature: 'string',
  appVersion: 'string',
  deviceModel: 'string',
  fcmId: '',
  manufacturer: 'string',
  platform: 'WEB',
  userAgent: 'Web',
}
export { formData, infoBean, initialValues }
